import { useSelector } from 'react-redux'
import { Button, Captcha, MultiInput } from 'sfy-react'
import styles from '../../../routes/Login/Login.module.scss'

const OTPForm = ({
  handleOnOTPChange,
  isDisabled,
  counter,
  showResend,
  sendRecaptcha,
  handleOnRequestOTP,
  handleOnVerifyOTP,
  className = {},
  isEmailLogin,
}) => {
  const translatedData = useSelector((state) => state.common.translatedData)
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        handleOnVerifyOTP(e, 'verifyOTPAndCreateConsumer')
      }}
    >
      <div className={className.inputContainer || ''}>
        <MultiInput
          length={6}
          handleOnChange={handleOnOTPChange}
          classNames={{ input: 'medium-font f14 default-font mt20 mb20 change-input-size' }}
          autoComplete='off'
        />
      </div>
      <Button className={`button mt20 mb20 button-primary`} isDisabled={isDisabled}>
        {translatedData.login.verify}
      </Button>
      {showResend && (
        <div className={`d-flex justify-between ${isEmailLogin ? 'align-center' : ''}`}>
          <div className={`mt20 mb20 ${styles['received-code-text']}`}>{translatedData.login['haveNotReceivedCode']}</div>
          <div className={`f12 mt20 mb20 ${styles['resend-code-text']}`}>
            {counter > 0 && `00:${counter.toString().length === 1 ? '0' : ''}${counter}`}
            {counter < 1 && (
              <>
                <Button
                  type='button'
                  classes={`button-link overflow-initial width-auto `}
                  handleOnClick={() => {
                    handleOnRequestOTP(true)
                  }}
                  text={translatedData.login['resendMobileCode']}
                />
                {!isEmailLogin && (
                  <Button
                    type='button'
                    classes={`button-link mt16 width-auto`}
                    handleOnClick={() => {
                      handleOnRequestOTP(true, true)
                    }}
                    text={translatedData.login['getOnCall']}
                  />
                )}
              </>
            )}
          </div>
        </div>
      )}
      {sendRecaptcha && <Captcha recaptcha={window.recaptcha} />}
    </form>
  )
}

export default OTPForm
